import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";

const CampaignsAdmin = () => {
    const [users, setUsers] = useState([]);
    const { jwtToken } = useOutletContext();
    const [totalPages, setTotalPages] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);

    const navigate = useNavigate();

    useEffect(() => {
        const headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + jwtToken);

        const requestOptions = {
            method: "GET",
            headers: headers,
        };
        fetch(
            `${process.env.REACT_APP_BACKEND}/api/campaigns/by-buyer?page=${currentPage}&status=1`,
            requestOptions
        )
            .then((response) => response.json())
            .then((data) => {
                setUsers(data);
                setTotalPages(data.totalPages);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    return (
        <div>
            <h1>Кампании покупателей</h1>

            {users.map((u) => (
                <table className="table table-stripped table-hover">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Регион/Город</th>
                            <th>Активность</th>
                            <th>Время</th>
                            <th>Дни</th>
                            <th>Цена</th>
                            <th>Дневной лимит</th>
                            <th>Баланс</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr key={u.id}>
                            <td>ID: {u.id}</td>
                            <td>
                                <Link to={`/users/${u.id}`}>{u.name}</Link>
                            </td>
                            <td colSpan={6}>Баланс: {u.balance / 100}</td>
                        </tr>
                        {u.campaigns.map((c) => (
                            <tr>
                                <td>{c.id}</td>
                                <td>
                                    <Link to={`/campaigns/${c.id}`}>
                                        {c.townOrRegionName}
                                    </Link>
                                </td>
                                <td>{c.activeStatus}</td>
                                <td>
                                    {c.timeFrom} - {c.timeTo}
                                </td>
                                <td>{c.days}</td>
                                <td>{c.price / 100}</td>
                                <td>{c.leadsDayLimit}</td>
                                <td>{c.balance / 100}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            ))}

            {/* <nav aria-label="Page navigation example">
                <ul className="pagination">
                    <li className="page-item">
                        <a
                            className="page-link"
                            href="#"
                            aria-label="Previous"
                            onClick={() =>
                                setCurrentPage((prev) => Math.max(prev - 1, 1))
                            }
                        >
                            <span aria-hidden="true">&laquo;</span>
                        </a>
                    </li>
                    {Array.from(Array(Math.min(totalPages, 10)).keys()).map(
                        (p) => (
                            <li
                                key={p}
                                className={`page-item ${
                                    p + 1 === currentPage ? "active" : ""
                                }`}
                            >
                                <a
                                    className="page-link"
                                    href="#"
                                    onClick={() => setCurrentPage(p + 1)}
                                >
                                    {p + 1}
                                </a>
                            </li>
                        )
                    )}
                    <li className="page-item">
                        <a
                            className="page-link"
                            href="#"
                            aria-label="Next"
                            onClick={() =>
                                setCurrentPage((prev) =>
                                    Math.min(prev + 1, totalPages)
                                )
                            }
                        >
                            <span aria-hidden="true">&raquo;</span>
                        </a>
                    </li>
                </ul>
            </nav> */}
        </div>
    );
};

export default CampaignsAdmin;
